import { render, staticRenderFns } from "./FindPwdSuc.vue?vue&type=template&id=becf00ca&scoped=true"
import script from "./FindPwdSuc.vue?vue&type=script&lang=js"
export * from "./FindPwdSuc.vue?vue&type=script&lang=js"
import style0 from "./FindPwdSuc.vue?vue&type=style&index=0&id=becf00ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf00ca",
  null
  
)

export default component.exports